import { Text } from '$components'

export type ColourCellProps = {
  colour: string,
  name: string,
}

export function ColourCell({ colour, name }: ColourCellProps) {

  return (
    <div className="flex items-center gap-stack-tight">
      <div
        style={{ backgroundColor: colour }}
        className="size-5 min-w-5 min-h-5 rounded-control"
      />

      <Text
        type="s"
        className="text-nowrap"
      >
        { name }
      </Text>
    </div>

  )
}
